import {Injectable} from '@angular/core';
import {ListLoader} from "../../interfaces/list-loader";
import {Saseung} from "../../models/saseung.model";
import {IsEmptyString, IsEmptyVar} from "../../defines/common.func";
import {SearchParam} from "../../defines/client.const";
import {Observable, throwError} from "rxjs";
import {catchError, finalize, map} from "rxjs/operators";
import {PAGE, SASEUNG2_HANGUL_API_URL} from "../../defines/protocol";
import {ApiService} from "../api/api.service";

@Injectable({
  providedIn: 'root'
})
export class SaseungHangulService implements ListLoader<string> {
  protected urlApi = SASEUNG2_HANGUL_API_URL;

  protected totalCount: number | null = null;
  protected listSaseung: Array<string> | null = null;
  private setSaseung: Set<string> | null = null;
  private nextUrl: string | null = null
  private load$: Observable<boolean> | null = null;

  constructor(
    private api: ApiService,
  ) { }

  /******************************************************************************
   * ListLoader<Saseung> 구현부
   *****************************************************************************/
  public getList(): Array<string> | null {
    return this.listSaseung;
  }
  public getCurCount(): number | null {
    // @ts-ignore
    return this.listSaseung?.length ?? null;
  }
  public getTotalCount(): number | null {
    return this.totalCount;
  }
  public IsComplete(): boolean {
    // @ts-ignore
    return this.totalCount === 0 ||
      (this.listSaseung && !IsEmptyVar(this.totalCount) && this.listSaseung.length === this.totalCount);
  }
  public IsLoading(): boolean {
    return this.load$ !== null;
  }
  public getById(id: string): string | null {
    return this.setSaseung?.has(id) ? id : null;
  }

  public ResetList(param: SearchParam | null = null): void {
    this.listSaseung = null;
    this.setSaseung = null;
    this.setSaseung = null;
    this.totalCount = null;
    this.nextUrl = this.urlApi;

    if (param) {
      if ('index' in param) {
        this.nextUrl = this.urlApi + '?index=' + param.index;
      }
    }

    // console.log('SaseungHangulService::ResetList()', this.urlApi, this.nextUrl);
  }

  public GetNextList(): Observable<boolean> {
    // console.log('SaseungHangulService::GetNextList()', this.urlApi, this.nextUrl);

    if (IsEmptyString(this.nextUrl)) {
      return throwError({error: 'No more pages in SaseungList'});
    }

    if (this.load$) {
      return this.load$;
    }

    return this.load$ = this.api.Get(this.nextUrl!).pipe(
      catchError(err => {
        if ('status' in err && err.status === 404) {
          this.totalCount = 0;
        }
        throw err;
      }),
      finalize(() => {
        this.load$ = null;
      }),
      map((data: PAGE) => {
        console.log('SaseungHangulService::GetNextList.api.Get data =', data);

        let first = false;
        if (this.totalCount === null) {
          this.totalCount = data.count;
          this.listSaseung = new Array<string>();
          this.setSaseung = new Set<string>();
          first = true;
        }
        else if (this.totalCount !== data.count) {
          console.error('[error]' + this.urlApi, data);
        }

        data.results.forEach(value => {
          const saseung = value as string;
          this.listSaseung?.push(saseung);
          this.setSaseung?.add(saseung);
        });

        this.nextUrl = data.next;

        return first;
      })
    );
  }

}
